import findKey from "lodash/findKey";
import { EMPTY_STRING_LABEL } from "../core/constants/appGlobals";
import { NullableNumber } from "../core/models/ModelHelpers";

export function isArrayValid(inputTest: unknown): boolean {
  return inputTest && Array.isArray(inputTest) && inputTest.length > 0;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isNumberValid(num: any) {
  if (num === undefined || num === null) {
    return false;
  }

  if (num === 0) {
    return true;
  }

  // if number, simple return true
  if (num && typeof num === "number") {
    return true;
  }
  // tries to cast string to number format
  else if (num && !isNaN(parseFloat(num))) {
    return true;
  }

  // else return false
  return false;
}

export function castNumberTo2Decimals(num?: number): number {
  if (!num) {
    return 0;
  }

  return Number(num.toFixed(2));
}

export function formatValue(value?: NullableNumber, numberOfDecimalCases = 0): string | number {
  if (value === undefined || value === null) {
    return EMPTY_STRING_LABEL;
  }

  return Number(value.toFixed(numberOfDecimalCases)).toLocaleString("pt-br");
}

export function formatValueWithCurrency(value?: NullableNumber): string | number {
  if (value === undefined || value === null) {
    return EMPTY_STRING_LABEL;
  }

  return value.toLocaleString("pt-br", { style: "currency", currency: "BRL" });
}

export function encodeStringToBase64(text: string): string {
  return new Buffer(text).toString("base64");
}

export function decodeStringFromBase64(base64: string): string {
  return new Buffer(base64, "base64").toString("ascii");
}

type keyValuePair = Record<string | number, unknown>[];
export function getKeyFromValue(value: string | number, items: keyValuePair) {
  return findKey(items, value);
}

export function padN(number: number, targetLength = 2) {
  let output = number + "";
  while (output.length < targetLength) {
    output = "0" + output;
  }
  return output;
}

export function isEmailValid(email: string): boolean {
  const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return regex.test(email.toLocaleLowerCase());
}

export function JsonTryParse(value: any) {
  try {
    return JSON.parse(value);
  } catch (e) {
    if (value === 'undefined') {
      return void 0;
    }
    return value;
  }
}